import {call, put} from "redux-saga/effects";
import {
    BASE_URL, INVITATION_LINK_GET,
    LOGIN_OR_REGISTER_POST, MY_DISCOUNTS_GET, MY_SHOW_DISCOUNTS_GET
} from "../../apis";
import axios from "axios";
import qs from "querystring";
import * as types from "./../types/stores.types";
import {actionChangeStatusProgressBar} from "../actions";

export function* loginUserSaga({payload: {mobile}}) {
    try {
        yield put(actionChangeStatusProgressBar(true));
        const response = yield call(axios.post, BASE_URL + LOGIN_OR_REGISTER_POST, qs.stringify({mobile}));
        const {status} = response.data;
        if (status === 'ok') {
            console.log('response', response);
        }
    } catch (e) {
        console.log(e);
    }finally {
        yield put(actionChangeStatusProgressBar(false));
    }
}

export function* activeCodeUserSaga() {

}

export function* resendCodeUserSaga() {

}

export function* fetchMyDiscounts({payload}) {
    try {
        yield put(actionChangeStatusProgressBar(true));
        yield put({type: types.CHANGE_LOADER_MODAL_MY_DISCOUNT, payload: {loader_modal: true}});
        const response = yield call(axios, BASE_URL + MY_DISCOUNTS_GET, {
            headers: {'Authorization': payload.token}
        });
        const {status, codes} = response.data;
        if (status === 'ok') {
            yield put({type: types.PUT_SET_MY_DISCOUNTS, payload: {codes}});
        }

    } catch (e) {

    } finally {
        yield put({type: types.CHANGE_LOADER_MODAL_MY_DISCOUNT, payload: {loader_modal: false}});
        yield put(actionChangeStatusProgressBar(false));
    }
}

export function* fetchShowMyDiscounts({payload}) {
    try {
        yield put(actionChangeStatusProgressBar(true));
        const response = yield call(axios, BASE_URL + MY_SHOW_DISCOUNTS_GET, {
            headers: {'Authorization': payload.token}
        });
        const {status, codes} = response.data;
        if (status === 'ok') {
            yield put({type: types.PUT_SET_DISCOUNTS_CODES, payload: {codes}});
        }
    } catch (e) {

    } finally {
        yield put(actionChangeStatusProgressBar(false));
    }
}

export function* fetchInvitation({payload}) {
    try {
        yield put(actionChangeStatusProgressBar(true));
        yield put({type: types.CHANGE_LOADER_MODAL_INVITATION, payload: {loader_modal: true}});
        const response = yield call(axios, BASE_URL + INVITATION_LINK_GET, {
            headers: {'Authorization': payload.token}
        });
        const {status, code, link, text} = response.data;
        if (status === 'ok') {
            yield put({type: types.PUT_INVITATION_LINK, payload: {code, link, text}});
        }
    } catch (e) {
        console.log(e);
    } finally {
        yield put({type: types.CHANGE_LOADER_MODAL_INVITATION, payload: {loader_modal: false}});
        yield put(actionChangeStatusProgressBar(false));
    }
}